import React, { useContext } from 'react'
import Box from 'transfix-ui/core/Box/Box'
import { UserContext } from 'apps/fleet-planner/context'
import { IStop } from 'apps/fleet-planner/types/loads'
import { DISPLAY } from 'constants/display'
import { formatFacilityName } from './CheckInCheckoutUtils'
import { formatDateTime } from './stops/utils'

interface ICheckinCheckoutTimesStopDetailsProps {
  stop: IStop
}

const CheckinCheckoutTimesStopDetails = ({ stop }: ICheckinCheckoutTimesStopDetailsProps) => {
  const { timeFormats } = useContext(UserContext)

  const { displayTimezone, endAt, startAt } = stop || {}
  const appointmentDateTime =
    formatDateTime(timeFormats, startAt, endAt, displayTimezone) || DISPLAY.empty
  const facilityName = formatFacilityName(stop)
  return (
    <Box mb={3} mt={2} display='grid' gridTemplateColumns='120px 1fr' gap='16px'>
      <span className='body-medium text-secondary'>Facility</span>
      <span className='body-medium b'>{facilityName} </span>
      <span className='body-medium text-secondary'>Appointment</span>
      <span className='body-medium b'>{appointmentDateTime}</span>
    </Box>
  )
}

export default CheckinCheckoutTimesStopDetails
